module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "E-mail",
      "value": this.contatos.emailCoordenador || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Telefone",
      "value": this.contatos.telefoneCoordenador || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos da ação de extensão")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Site",
      "value": this.contatos.site || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Instagram",
      "value": this.contatos.instagram || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Facebook",
      "value": this.contatos.facebook || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Youtube",
      "value": this.contatos.youtube || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field-pre-format', {
    attrs: {
      "readonly": "",
      "label": "Outras mídias sociais",
      "value": this.contatos.midiasSociais || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Nome do contato",
      "value": this.contatos.nomeContato || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "E-mail",
      "value": this.contatos.email || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Telefone",
      "value": this.contatos.telefone || '-'
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": _vm.habilitaRelatorio() ? 'RelatoriosProjeto' : null,
      "editar": "EditarContatos",
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf3ad250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-contatos.vue
// module id = 475
// module chunks = 0